import { useQueries } from "react-query";
import { getUserByAccountId } from "../../api/people-api";
import { getUserByAccountIdWithCosmosData } from "../../api/cosmos-api";
import { mapUser } from "./mapPeople";

function simpleMap(user) {
  return {
    accountId: user.accountId,
    name: user.publicName,
  };
}

export const usePeople = (data, cosmosData) =>
  useQueries(
    data.map((user) => {
      return {
        queryKey: [
          `people-${cosmosData.fetchWithCosmosData}`,
          user.accountId,
          user.id,
        ],
        queryFn: () => {
          if (!user.accountId) {
            return { isNew: true, loading: false, id: user.id };
          }
          if (cosmosData.fetchWithCosmosData) {
            return getUserByAccountIdWithCosmosData(user.accountId);
          }
          return getUserByAccountId(user.accountId);
        },
        retry: 0,
        placeholderData: {
          data: {
            accountId: user.accountId,
            isPlaceholder: true,
            loading: true,
          },
        },
        select: (response) => {
          if (cosmosData.fetchWithCosmosData) {
            return mapUser(response?.data || {}, cosmosData);
          }

          if (response.isPlaceholder || response.isNew) {
            return response;
          }
          const result = JSON.parse(response?.body || "{}");
          return {
            ...simpleMap(result),
            id: data.find((x) => x.id.toString() === user.id).id,
          };
        },
      };
    })
  );
